var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-cards"},[_vm._l((_vm.logs),function(log,index){return [_c('history-card',{key:index,attrs:{"log":log}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }